import React from "react";
import ChecksList from "./ChecksList";
import CheckDetails from "./CheckDetails";
import Notifications from "./Notifications";
import classes from "./Body.module.css";
import Tabs from '../../../../components/Tabs';
import Aux from '../../../../components/AuxComponent';
import FBCommonUtil from '../../../Fireboard/common';
import MenuUTIL from '../../../../util/menu-utils';
import constants from '../../../../globalization';
import Whiteboard from '../../../Playground/components/Body/Whiteboard';
import FireboardUtils from "../../../../util/fireboard-util";

export default function Desktop(props) {
  const {
    setSelectedCheck = () => { },
    showSearchBox,
    selectedDate,
    onDateChange,
    onlineOrderAdvanceLimit,
    resetFilterCalendar,
    handleChange,
    searchChecks,
    onSearchReset,
    selectedItem = {},
    items = [],
    checksRowData = [],
    supportsTipsOnTotalAmount = false,
    showMemberDetailPopup = () => { },
    notificationsData = [],
    showNotifications = false,
    removeNewTag = () => { },
    onPrintPress,
    isFutureOrderType,
    getManagerNotifications,
    activeMgrFilter,
    managerMode,
    pendingItems,
    showApprovalReasonsPopup,
    currentView,
    selectedTable,
    layout,
    selectShape = () => { },
    selectedShapeId,
    currency,
    iso2,
    suppressTipsOnFireBoard,
    acknowledgeIdCheck,
    sortFilter,
    printLogs = [],
  } = props || {};

  if (showNotifications) {
    return (
      <div className={classes.container}>
        <Notifications
          notificationsData={notificationsData}
          removeNewTag={removeNewTag}
        />
      </div>
    );
  }

  const getSelectedCheck = (check) => {
    return checksRowData.find(ch => ch.id === check.id);
  }

  const getTabView = () => {
    return <Tabs tabsContainerStyle={classes.tabsContainer} tabsStyle={classes.ulStyle}>
      {selectedTable?.checks.map(item => {
        let items = item && item.items;
        let pendingCheckItems = [];
        const isPOSOrder = FBCommonUtil.getOrderTypeFromSourceType(item.sourceType) === constants.orderType_POS;
        if (isPOSOrder) {
          items = FireboardUtils.updatePOSItems(item);
          const pendingItems = MenuUTIL.getPendingItemsFromCheck(item);
          pendingCheckItems = FireboardUtils.updatePendingPOSItems(pendingItems, item);
        }
        return <Aux name={item.checkNumber} key={item.id}>
          <CheckDetails
            checkDetailsStyles={classes.checksDetails}
            selectedItem={getSelectedCheck(item)}
            items={items}
            supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
            showMemberDetailPopup={showMemberDetailPopup}
            onPrintPress={onPrintPress}
            getManagerNotifications={getManagerNotifications}
            pendingItems={pendingCheckItems}
            showApprovalReasonsPopup={showApprovalReasonsPopup}
          />
        </Aux>
      })}
    </Tabs>
  };


  return (
    <div className={classes.container}>
      {currentView ?
        <>
          <div className={classes.whiteboard}>
            <Whiteboard
              layout={layout}
              draggable={false}
              selectShape={selectShape}
              selectedShapeId={selectedShapeId} />
          </div>
          {selectedTable && selectedTable.checks ? getTabView() : <CheckDetails />}
        </>
        :
        <>
          <div className={classes.checklistContainer}>
            <ChecksList
              checksRowData={checksRowData}
              setSelectedCheck={setSelectedCheck}
              selectedItem={selectedItem}
              showSearchBox={showSearchBox}
              handleChange={handleChange}
              searchChecks={searchChecks}
              onSearchReset={onSearchReset}
              selectedDate={selectedDate}
              onDateChange={onDateChange}
              onlineOrderAdvanceLimit={onlineOrderAdvanceLimit}
              resetFilterCalendar={resetFilterCalendar}
              isFutureOrderType={isFutureOrderType}
              activeMgrFilter={activeMgrFilter}
              managerMode={managerMode}
              currency={currency}
              iso2={iso2}
              sortFilter={sortFilter}
            />
            <PrintLog printLogs={printLogs} />
          </div>
          <CheckDetails
            selectedItem={selectedItem}
            items={items}
            supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
            showMemberDetailPopup={showMemberDetailPopup}
            onPrintPress={onPrintPress}
            getManagerNotifications={getManagerNotifications}
            pendingItems={pendingItems}
            showApprovalReasonsPopup={showApprovalReasonsPopup}
            currency={currency}
            iso2={iso2}
            suppressTipsOnFireBoard={suppressTipsOnFireBoard}
            acknowledgeIdCheck={acknowledgeIdCheck}
          />
        </>
      }
    </div>
  );
}

const PrintLog = ({ printLogs }) => {
  return (
    <div className={classes.printLogsWrapper}>
      {printLogs.map(log =>
        <div key={log} className={classes.printLogText}>{log}</div>
      )}
    </div>
  );
};
